import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import scrapedData from './kampus_content.json';

const menuItems = [
  { label: 'Görsel Sanatlar', id: 'gorsel' },
  { label: 'Müzik Odası', id: 'muzik' },
  { label: 'Montessori Atölyeleri', id: 'montessori' },
  { label: 'Yemekhaneler', id: 'yemekhane' },
  { label: 'Bahçe Alanları', id: 'bahce' },
  { label: 'Eğitim Öğretim Alanları', id: 'egitim' },
  { label: 'Kültür Sanat Alanları', id: 'kultur' },
  { label: 'Spor Kompleksleri', id: 'spor' },
  { label: 'Teknoloji Laboratuvarı', id: 'teknoloji' },
  { label: 'Fen Laboratuvarı', id: 'fen' },
];

const KampusOlanaklari = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white text-gray-800" style={{ backgroundImage: "url('/background.png')" }}>
      {/* Sol Menü */}
      <aside className="md:w-64 w-full bg-[#8b0000] text-white p-4 space-y-2 md:sticky top-0 mt-[72px] md:self-start z-10">
        <h2 className="text-xl font-bold mb-4">KAMPÜS OLANAKLARI</h2>
        {menuItems.map((item, idx) => (
          <a
            key={idx}
            href={`#${item.id}`}
            className="block px-4 py-3 border-b border-white hover:bg-white hover:text-[#8b0000] transition font-medium text-sm"
          >
            <span className="mr-2">❯</span> {item.label}
          </a>
        ))}
      </aside>

      {/* İçerik */}
      <main className="flex-1 p-6 md:p-12 space-y-16">
        {menuItems.map((item) => {
          const sectionData = scrapedData.find((data) => data.id === item.id);
          return (
            <section key={item.id} id={item.id} className="py-10 scroll-mt-24">
              <h2 className="text-2xl font-bold text-[#a03838] mb-4">{item.label}</h2>
              {sectionData?.text && <p className="mb-4 whitespace-pre-line">{sectionData.text}</p>}
              {sectionData?.images?.length > 0 && (
                <div className="flex flex-wrap gap-4">
                  {sectionData.images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt={`img-${item.id}-${i}`}
                      className="w-full md:w-1/2 lg:w-1/3 rounded-lg shadow"
                    />
                  ))}
                </div>
              )}
            </section>
          );
        })}
      </main>
    </div>
  );
};

export default KampusOlanaklari;

// import React from 'react';
// import scrapedData from './kampus_content.json';

// const menuItems = [
//   { label: 'Görsel Sanatlar', id: 'gorsel' },
//   { label: 'Müzik Odası', id: 'muzik' },
//   { label: 'Montessori Atölyeleri', id: 'montessori' },
//   { label: 'Yemekhaneler', id: 'yemekhane' },
//   { label: 'Bahçe Alanları', id: 'bahce' },
//   { label: 'Eğitim Öğretim Alanları', id: 'egitim' },
//   { label: 'Kültür Sanat Alanları', id: 'kultur' },
//   { label: 'Spor Kompleksleri', id: 'spor' },
//   { label: 'Teknoloji Laboratuvarı', id: 'teknoloji' },
//   { label: 'Fen Laboratuvarı', id: 'fen' },
// ];

// const KampusOlanaklari = () => {
//   return (
//     <div className="flex flex-col md:flex-row min-h-screen bg-white text-gray-800" style={{ backgroundImage: "url('/background.png')" }}>
//       {/* Sol Menü */}
//       <aside className="md:w-64 w-full bg-[#8b0000] text-white p-4 space-y-2 sticky top-[64px] self-start z-10">
//         <h2 className="text-xl font-bold mb-4">KAMPÜS OLANAKLARI</h2>
//         {menuItems.map((item, idx) => (
//           <a
//             key={idx}
//             href={`#${item.id}`}
//             className="block px-4 py-3 border-b border-white hover:bg-white hover:text-[#8b0000] transition font-medium text-sm"
//           >
//             <span className="mr-2">❯</span> {item.label}
//           </a>
//         ))}
//       </aside>

//       {/* İçerik */}
//       <main className="flex-1 p-6 md:p-12 space-y-16">
//         {menuItems.map((item) => {
//           const sectionData = scrapedData.find((data) => data.id === item.id);
//           return (
//             <section key={item.id} id={item.id} className="py-10 scroll-mt-24">
//               <h2 className="text-2xl font-bold text-[#a03838] mb-4">{item.label}</h2>
//               {sectionData?.text && <p className="mb-4 whitespace-pre-line">{sectionData.text}</p>}
//               {sectionData?.images?.length > 0 && (
//                 <div className="flex flex-wrap gap-4">
//                   {sectionData.images.map((img, i) => (
//                     <img
//                       key={i}
//                       src={img}
//                       alt={`img-${item.id}-${i}`}
//                       className="w-full md:w-1/2 lg:w-1/3 rounded-lg shadow"
//                     />
//                   ))}
//                 </div>
//               )}
//             </section>
//           );
//         })}
//       </main>
//     </div>
//   );
// };

// export default KampusOlanaklari;
